import script from "./UserProfileComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileComponent.vue?vue&type=style&index=0&id=133a721a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133a721a"]])

export default __exports__